export const IconListGrid: {
  name: 'icon_list_grid-f51c429dc0b2'
} = {
  name: 'icon_list_grid-f51c429dc0b2'
}
